import _ from 'lodash'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.scss'
import { launcherOpenUrl } from '../../launcherBackend/launcher-command'
import rating from '../../settings/rating.json'

class Rating extends Component {
    static renderAssets(type) {
        if (!rating[type].assets || rating[type].assets.length === 0) return null

        return _.map(rating[type].assets, value => (
            <img src={value.uri} alt={value.alt} key={value.alt} />
        ))
    }

    static renderRatingType(type) {
        if (!rating[type] || !rating[type].uri) return null

        return (
            <a role="button" tabIndex="0" onClick={() => launcherOpenUrl(rating[type].uri)}>
                {Rating.renderAssets(type)}
            </a>
        )
    }

    constructor(props) {
        super(props)

        this.state = {
            styles: [styles.ratings, this.props.parentStyles],
            hidden: false,
        }

        this.willUnmount = false
    }

    componentDidMount() {
        // Start a timeout for hiding the ratings symbols
        this.timeout = setTimeout(() => {
            // Get the current state styles
            const stateStyles = [...this.state.styles]

            // Add the hidden style
            stateStyles.push(styles.hidden)

            // Update the state
            this.setStateIff({
                styles: stateStyles,
            })

            // Set a timeout for hiding the component
            this.timeout = setTimeout(() => {
                // Update the state
                this.setStateIff({
                    hidden: true,
                })
            }, 2000)
        }, rating.hideTimerSeconds * 1000)
    }

    componentWillUnmount() {
        this.willUnmount = true
        clearTimeout(this.timeout)
    }

    setStateIff = (state) => {
        if (this.willUnmount) return

        this.setState(state)
    }

    render() {
        if (this.state.hidden || !rating.active) return null

        const className =
            typeof this.state.styles === 'object' ? this.state.styles.join(' ') : this.state.styles

        return <div className={className}>{Rating.renderRatingType(rating.active)}</div>
    }
}

Rating.propTypes = {
    parentStyles: PropTypes.string,
}

Rating.defaultProps = {
    parentStyles: '',
}

export default Rating



// WEBPACK FOOTER //
// ./src/components/Rating/index.js